// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"e604e72b","114":"82183f13","240":"9e06a794","356":"ec953fd6","453":"15a626a8","473":"c5dfc50a","493":"44485552","699":"a3296771","846":"5f905689","874":"afbd988a","902":"1198cc6e"}[chunkId] + ".chunk.js";
};